import React, { useCallback, useMemo } from 'react';
import { NavigationMenuItem } from '../../models/NavigationMenuItem';
import { getCollectionHandle } from '../../utils/utils';
import useMobileMenu from '../../hooks/useMobileMenu';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import {
    ListItem,
    ListItemButton,
    ListItemText,
    Typography,
    useMediaQuery,
    useTheme,
} from '@mui/material';
import NavigationList from './navigation-list';

interface NavigationItemProps {
    item: NavigationMenuItem;
    onClick?: (item: NavigationMenuItem) => void;
}

const NavigationItem: React.FC<NavigationItemProps> = (props) => {
    const { item, onClick } = props;

    const menu = useMobileMenu();

    const { t } = useTranslation();

    const navigate = useNavigate();

    const theme = useTheme();

    const smMd = useMediaQuery(theme.breakpoints.down(1100));

    const handleClick = useCallback((): void => {
        switch (item.type) {
            case 'PAGE':
                window.location.replace(item.url);
                break;
            case 'ROUTE':
                navigate(item.url);
                break;
            case 'COLLECTION':
                navigate('collections/' + getCollectionHandle(item.url));
                break;
            default:
                onClick?.(item);
        }
        menu.closeAllMobileMenu();
    }, []);

    const match = window.location.pathname === item.url;

    const title = useMemo(() => {
        switch (item.type) {
            case 'GROUP':
                return (
                    <Typography variant="h6" paddingLeft={2} paddingY={1}>
                        {t(item.title)}
                    </Typography>
                );
            default: {
                return (
                    <ListItem disablePadding>
                        <ListItemButton
                            onClick={handleClick}
                            focusRipple={false}
                            sx={{
                                color: theme.palette.primary[400],
                                borderRadius: '8px',
                                '&:hover': {
                                    backgroundColor: smMd
                                        ? undefined
                                        : 'transparent',
                                },
                            }}
                        >
                            <ListItemText
                                primary={
                                    <Typography
                                        style={{
                                            color:
                                                item.color ??
                                                (match &&
                                                    theme.palette.primary[400]),
                                        }}
                                    >
                                        {t(item.title)}
                                    </Typography>
                                }
                            />
                        </ListItemButton>
                    </ListItem>
                );
            }
        }
    }, [t, theme, match]);

    return (
        <>
            {title}
            {item?.items?.length > 0 && (
                <NavigationList menu={item} />
            )}
        </>
    );
};

export default NavigationItem;
